<template>
    <bottom-sheet>
        <template #title>
            <span>Add balance {{ currentAsset.symbol }}</span>
        </template>

        <sheet-section v-if="currentAsset.balances.length" label="Balances">
            <record-row v-for="balance in currentAsset.balances" :key="balance.public_id" class="balance-row">
                <div>
                    <a href="#" class="balance-bucket" @click.prevent="changeBucket(balance.bucket)">{{ balance.bucket.name }}</a>
                    <span v-if="balance.bucket.type === 'trading'" class="balance-trading">&#8226;</span>
                </div>
                <div class="mono">{{ formatHoldings(balance.shares) }}</div>
                <div class="mono">${{ formatHoldings(balance.shares * currentAsset.price) }}</div>
                <div class="record-date">{{ formatTimeFromISO(balance.last_check + 'Z') }}</div>
            </record-row>
        </sheet-section>

        <form autocomplete="off" @submit.prevent="onSubmit">
            <sheet-section label="Add">
                <form-row label="Bucket">
                    <sheet-select v-model="form.bucket" :options="bucketFormOptions" placeholder="Bucket" />
                </form-row>
                <form-row label="Balance">
                    <input v-model="form.balance" type="number" step="any" inputmode="decimal" class="sheet-input">
                </form-row>
            </sheet-section>
        </form>

        <template #actions>
            <button
                type="button"
                class="sheet-btn sheet-btn-primary"
                :disabled="!canSubmit || addBalanceBusy"
                @click="onSubmit"
            >
                <b-spinner v-if="addBalanceBusy" small />
                Add
            </button>
        </template>
    </bottom-sheet>
</template>

<script>
import apiMixin from '@/mixins/api';
import bucketMixin from '@/mixins/bucketMixin';
import formatter from '../../mixins/formatter'
import BottomSheet from '@/components/sheet/BottomSheet.vue';
import SheetSection from '@/components/sheet/SheetSection.vue';
import RecordRow from '@/components/sheet/RecordRow.vue';
import FormRow from '@/components/sheet/FormRow.vue';
import SheetSelect from '@/components/sheet/SheetSelect.vue';

export default {
    name: 'AddBalance',
    props: ['assetContext'],
    mixins: [apiMixin, bucketMixin, formatter],
    components: { BottomSheet, SheetSection, RecordRow, FormRow, SheetSelect },
    data() {
        return {
            currentAsset: null,

            form: {
                bucket: null,
                balance: null,
            },
            addBalanceBusy: false,
        }
    },
    created() {
        this.currentAsset = this.$store.getters.getAssetBySymbol(this.assetContext.symbol);
    },
    methods: {
        changeBucket(bucket) {
            this.form.bucket = bucket.public_id;
        },
        async onSubmit() {
            if (!this.canSubmit) return;

            this.addBalanceBusy = true;

            const response = await this.apiPost(
                '/api/bucket/' + this.form.bucket + '/add-balance',
                {
                    asset_symbol: this.currentAsset.symbol,
                    balance_value: parseFloat(this.form.balance)
                }
            );

            this.addBalanceBusy = false;

            if (response) {
                await this.$store.dispatch('updateAssets', [response.data.asset]);
                this.$FModal.hide();
            }
        },
    },
    computed: {
        canSubmit() {
            if (this.form.bucket && this.form.balance) return true;
            return false;
        },
    }
}
</script>

<style scoped>
/* a check time or a date from an earlier year needs more room than the narrow status column */
.balance-row ::v-deep .record-cells {
    grid-template-columns: 1.2fr 1fr 1fr auto;
}
.balance-bucket {
    color: var(--sheet-link);
}
.balance-trading {
    margin-left: 3px;
    color: var(--sheet-link);
    font-size: 10px;
}
</style>
